import ImmutableQueue from '../../common/collection/queue/ImmutableQueue'
import {updateModalFlags} from '../../modules/modal/modalReducerHelpers'
import {getModalStateFlagName} from '../../modules/modal/modalUtils'
import {MODAL_IDS} from '../../modules/modal/modalConstants'

function generateDefaultInitialModalState() {
  return {
    openModalCount: 0,
    maxOpenModalLimit: 2,
    modalQueue: new ImmutableQueue(),
    flags: {
      isAddToCartModalOpen: false,
      isProductSortTypeSelectorModalOpen: false,
      isSuccessfulAddToCartFeedbackDialogOpen: false,
      isInternationalSalesModalOpen: false,
      isOtherMerchantsModalOpen: false,
      isTrustLabelModalOpen: false,
      isSizeChartModalOpen: false,
      isEnergyClassModalOpen: false,
      isErrorModalOpen: false,
    },
  };
}

/* eslint-disable complexity */
function modalReducer(state = generateDefaultInitialModalState(), action) {
  let newState;

  switch (action.type) {
    case 'SET_MODAL_STATE': {
      newState = {
        ...state,
        ...updateModalFlags(state, {
          [getModalStateFlagName(action.payload.modalId)]: action.payload.isOpen,
        }),
      };

      break;
    }

    case 'OPEN_MODAL': {
      newState = {
        ...state,
        ...updateModalFlags(state, {
          [getModalStateFlagName(action.payload.modalId)]: true,
        }),
      };

      break;
    }

    case 'CLOSE_MODAL': {
      newState = {
        ...state,
        ...updateModalFlags(state, {
          [getModalStateFlagName(action.payload.modalId)]: false,
        }),
      };

      break;
    }

    case 'REDUX_ERROR_OCCURED': {
      newState = {
        ...generateDefaultInitialModalState(),
      };

      break;
    }

    case 'CLOSE_ALL_MODALS': {
      newState = {
        ...generateDefaultInitialModalState(),
      };

      break;
    }

    case 'LEAVE_CATEGORY_PAGE_ROUTE':
    case 'LEAVE_BRAND_CATEGORY_PAGE_ROUTE': {
      newState = {
        ...state,
        ...updateModalFlags(state, {
          [getModalStateFlagName(MODAL_IDS.ADD_TO_CART_MODAL)]: false,
          [getModalStateFlagName(MODAL_IDS.PRODUCT_SORT_TYPE_SELECTOR_MODAL)]: false,
          [getModalStateFlagName(MODAL_IDS.SUCCESSFUL_ADD_TO_CART_FEEDBACK_DIALOG)]: false,
        }),
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

/* eslint-enable complexity */

export {generateDefaultInitialModalState};
export default modalReducer;
